<template>
  <div class="vcv-billing-info">
    <div class="vcv-billing-info__block">
      <div>
        {{ $tr('rates.currentRate') }}:
        <strong class="vcv-billing-info__block-name">{{ tariffName }}</strong>
      </div>
      <div v-if="rates.paid_to !== null">
        {{ $tr('rates.date.end') }}: {{ $moment(rates.paid_to).format('DD.MM.YYYY') }}
      </div>
    </div>

    <div class="vcv-billing-info__block">
      <div>
        <strong>{{ $tr('rates.availableResponses') }}</strong>
      </div>

      <div>
        {{ $tr('rates.monthly-limit') }}:
        <span
          :class="{
            red: Number(rates.monthly_response_limit || 0) <= 10,
            orange: Number(rates.monthly_response_limit || 0) <= 25 && Number(rates.monthly_response_limit || 0) > 10
          }"
        >
          {{ rates.monthly_response_limit || 0 }}
        </span>
        / {{ tariffMonthlyResponses }}
      </div>
      <div v-if="rates.response_balance && rates.response_limit">
        {{ $tr('responses.tabs.additional.name') }}: {{ rates.response_balance }} / {{ rates.response_limit }}
      </div>
    </div>

    <div
      v-if="rates.responses_lifetime || rates.monthly_hd_response_limit || rates.monthly_fullhd_response_limit"
      class="vcv-billing-info__block"
    >
      <div v-if="rates.responses_lifetime">
        {{ $tr('billing.response-time') }}: {{ rates.responses_lifetime }}
        {{
          declOfNum(rates.responses_lifetime, [$tr('common.1-month'), $tr('common.2-months'), $tr('common.5-months')])
        }}
      </div>

      <div v-if="rates.monthly_hd_response_limit !== null && Number(rates.monthly_hd_response_limit) > 0">
        HD {{ $tr('billing.video') }}: {{ rates.monthly_hd_response_limit || 0 }}
      </div>

      <div v-if="rates.monthly_fullhd_response_limit !== null && Number(rates.monthly_fullhd_response_limit) > 0">
        FullHD {{ $tr('billing.video') }} {{ rates.monthly_fullhd_response_limit || 0 }}
      </div>
    </div>

    <div v-if="rates.is_sms_enabled" class="vcv-billing-info__block">
      <div>
        <strong>{{ $tr('rates.available-sms') }}</strong>
      </div>

      <div v-if="!rates.is_sms_unlimited">
        {{ $tr('admin_console.companies.table.limit') }}: {{ rates.sms_balance }}
      </div>

      <div v-else>
        {{ $tr('admin_console.company.general.noLimit') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { declOfNum } from '@/_helpers/utils.js';

export default {
  computed: {
    ...mapState('company_new', ['rates']),

    ...mapGetters('company_new', ['getTariffById']),

    tariffName() {
      if (this.getTariffById(this.rates.tariff_id) !== null) {
        return this.getTariffById(this.rates.tariff_id).name;
      }

      return '';
    },

    tariffMonthlyResponses() {
      if (this.getTariffById(this.rates.tariff_id) !== null) {
        return this.getTariffById(this.rates.tariff_id).monthly_responses;
      }

      return 0;
    }
  },

  methods: {
    declOfNum
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.vcv-billing-info {
  box-shadow: $box-shadow;
  padding: 15px 0;
  background: #fff;
  margin-bottom: 20px;
  display: flex;
  line-height: 1.5;

  @media screen and (max-width: 1500px) {
    flex-direction: column;
    padding: 10px 20px;
    margin-bottom: 20px;
  }

  @media screen and (max-width: 600px) {
    width: 90%;
    margin: 0 auto 30px;
    padding: 10px 20px;
  }

  &__block {
    @include mixin-text-tag;
    padding: 0 20px;
    border-right: 1px solid $grey-light;

    @media screen and (max-width: 1500px) {
      border-right: none;
      padding: 10px 0;
    }

    &:last-child {
      border-right: none;
      border-bottom: none;
    }

    .icon-check {
      color: $green;
    }

    .red {
      color: $red;
    }

    .orange {
      color: $orange;
    }
  }

  &__block-name {
    text-transform: capitalize;
  }
}
</style>
